import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import SearchBox from '../Common-Components/SearchBox';
import '../common-css/Table.css';
import { deleteItem, showTableResponse, sortInAlphabeticalOrder } from '../common-helpers/commonServices';
import NEET_SubjectModal from './NEET_SubjectModal';


const NeetSubject = () => {
    const childRef = useRef();
    const [subjects, setSubjects] = useState([]);
    // const [courses, setCourses] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadSubjects, setSubjectLoading] = useState(false);

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects').then((res) => {
            let subjects = sortInAlphabeticalOrder(res.data.subjects, 'Subject');
            setSubjects(subjects);
            setChecked(subjects);
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message)
        })

    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked.length / pageSize);
    const number = [...Array(npage + 1).keys()].slice(1)


    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className=' col-sm-8 d-flex justify-content-between'>
                                        <div className="col-12 col-md-auto">
                                            <button type="button" className=" btn btn-dark btn-xs "
                                                style={{ whiteSpace: 'nowrap', backgroundColor: '#274065', borderColor: '#274065' }}
                                                onClick={() => childRef.current.openModal()}
                                            >
                                                + SUBJECT NAME
                                            </button>
                                        </div>
                                        {/* <div className="col-10 d-flex justify-content-start ">
                                            <div className="col-6">
                                                <div className="basic-dropdown">
                                                    <Select
                                                        value={{ value: selectedCourse, label: selectedCourse }}
                                                        onChange={(selectedOption) => selectSubjectTypeHandler(selectedOption.value)}
                                                        options={['All Subject types', 'Section-IA', 'Section-II', 'Section-III']?.map((course) => ({ value: course, label: course }))}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                width: '100%',
                                                                backgroundColor: 'transparent', // Adjust as needed
                                                                borderColor: '#17a2b8', // Adjust as needed

                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div> */}

                                    </div>
                                    <div className=" col-sm-4 input-group search-area mb-md-0 mb-3">
                                        <SearchBox setChecked={setChecked} dataArray={subjects} searchingProperty={'Subject'} />
                                    </div>
                                </div>

                            </div>
                            {/* <ProdutsDetailsTabsAtTop setChecked={setChecked} totalItems={subjects} totalActiveItems={totalActiveSubjects} totalInactiveItems={totalInactiveSubjects} totalArchivedItems={totalArchivedSubjects} /> */}
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">
                                {/* <div>
                                    <Button variant="danger ms-3" size='xs' onClick={(e) => bulkOperations("delete", records, '/hideSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Delete</Button>
                                    <Button variant="success ms-3 " size='xs' onClick={(e) => bulkOperations("activate", records, '/activateSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Active</Button>
                                    <Button variant="warning ms-3" size='xs' onClick={(e) => bulkOperations("InActivate", records, '/inActivateSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Inactive</Button>
                                </div> */}

                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                <th className=' custom-table-header p-2' style={{ width: "50px" }}>S.No</th>
                                                <th className=' custom-table-header p-2 text-start'>SUBJECTS</th>
                                                <th className=' custom-table-header p-2 text-center' style={{ width: "100px" }}>ACTION</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >


                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className="mb-0 fw-bold">
                                                            {ind + 1 + firstIndex}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Subject}
                                                            </h6>
                                                        </div>
                                                    </td>
                                                    <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "100px" }}>
                                                        <CiEdit cursor='pointer' title='Edit Subject' size={18} className='text-info'
                                                            onClick={() => childRef.current.openModal(item)} />
                                                        <MdDeleteOutline color="red" title='Delete Subject' cursor='pointer' size={18} className='ms-2'
                                                            onClick={() => deleteItem(item.Sn, 'SUBJECT', '/neet/deleteSubject/', setSubjectLoading, loadSubjects)} />
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NEET_SubjectModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default NeetSubject;
